export default "__VITE_ASSET__bIyIA8Dk__";